// extracted by mini-css-extract-plugin
export var actionButton = "_qd-0";
export var actionMenuContainer = "_qd-i";
export var bubble = "_qd-2";
export var bubbleActionMenu = "_qd-j";
export var bubbleContext = "_qd-6";
export var bubbleItems = "_qd-7";
export var customer = "_qd-3";
export var divider = "_qd-8";
export var fileList = "_qd-9";
export var hiddenComment = "_qd-o";
export var infoAbove = "_qd-a";
export var internal = "_qd-4";
export var lightActionButton = "_qd-1";
export var link = "_qd-b";
export var merchant = "_qd-5";
export var message = "_qd-c";
export var profilePicture = "_qd-e";
export var quillToolbarContainer = "_qd-f";
export var senderDate = "_qd-g";
export var senderDateCustomer = "_qd-h";
export var senderName = "_qd-d";
export var time = "_qd-k";
export var uploadedImage = "_qd-l";
export var username = "_qd-m";
export var xsmall = "_qd-n";